import React, { memo, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import { mdiCalendarAccountOutline } from '@mdi/js';
import Icon from '@mdi/react';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import { Tooltip } from '@material-ui/core';
import { useForm } from 'react-final-form';
import OptionsStepCard from './OptionsStepCard';
import { scrollToTop } from '../../../shared/utils/smartutils';
import Modal from '../../../shared/components/Modal';

const CourseStep = (props) => {
  const { t, data, meta, removeCourseStep } = props;
  const [cards, setCards] = useState([]);
  const form = useForm();
  const [modal, setModal] = useState(false);
  const [removeCardStep, setRemoveCardStep] = useState({});

  const toggleModal = () => {
    setModal(!modal);
  };

  const cardNameChangeInput = (evt, index) => {
    if (evt) {
      const updatedCards = [...cards];
      updatedCards[index] = {
        ...updatedCards[index],
        fullName: evt.target.value,
      };
      setCards(updatedCards);
    }
  };

  const cardDurationChange = ({ value }, index) => {
    const updatedCards = [...cards];
    updatedCards[index] = {
      ...updatedCards[index],
      duration: value,
    };
    setCards(updatedCards);
  };

  const cardQuantityCyclesChangeInput = (evt, index) => {
    const { value } = evt.target;
    const regexExp = new RegExp(/\d/g);
    if (evt && regexExp.test(value)) {
      const updatedCards = [...cards];
      updatedCards[index] = {
        ...updatedCards[index],
        cycleQuantity: parseFloat(value, 10),
      };
      setCards(updatedCards);
    }
  };

  const removeStep = () => {
    toggleModal();
    removeCourseStep(removeCardStep);
  };

  const removeCard = (item, index) => {
    if (item.id) {
      toggleModal();
      setRemoveCardStep(item);
    } else {
      const updatedCards = [...cards];
      updatedCards.splice(index, 1);
      setCards(updatedCards);
    }
  };

  useEffect(() => setCards(data), [data]);

  useEffect(() => {
    form.change('steps', cards);
  }, [cards]);

  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={removeStep}
      />
      <div className="course-steps-container">
        {cards.map((item, index) => (
          <div key={item.id} className="step-card-container">
            <div className="step-card-body">
              <CloseIcon
                className="step-card-icon-delete"
                onClick={() => removeCard(item, index)}
              />
              <div className="step-card-icon-header">
                <Icon path={mdiCalendarAccountOutline} size={1} />
              </div>
              <div className="step-card-body-content">
                <div className="input-group">
                  <span className="label">{t('general.name')}</span>
                  <input
                    name="fullName"
                    type="text"
                    value={item.fullName}
                    placeholder={t('placeholder.course.name')}
                    onChange={(evt) => cardNameChangeInput(evt, index)}
                    required
                  />
                </div>
                <div className="input-group">
                  <span className="label">{t('general.duration')}</span>
                  <OptionsStepCard
                    duration={item.duration}
                    handleChange={(value) => cardDurationChange(value, index)}
                  />
                </div>
                <div className="input-group">
                  <span className="label">{t('general.quantity-cycles')}</span>
                  <input
                    name="cycleQuantity"
                    type="number"
                    min={1}
                    max={99}
                    value={item.cycleQuantity}
                    placeholder={t('placeholder.course.name')}
                    onChange={(evt) =>
                      cardQuantityCyclesChangeInput(evt, index)
                    }
                  />
                </div>
              </div>
            </div>
            <hr className="line-card" />
          </div>
        ))}
        <div className="add-step">
          <hr />
          <Tooltip title={t('general.add')} arrow>
            <button
              type="button"
              onClick={() =>
                setCards([...cards, { id: 0, cycleQuantity: 1, duration: 'A' }])
              }
            >
              <AddIcon />
            </button>
          </Tooltip>
        </div>
      </div>
      {meta.touched && meta.error && (
        <span className="form__form-group-error">
          {meta.error}
          {scrollToTop()}
        </span>
      )}
    </div>
  );
};

CourseStep.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape),
  removeCourseStep: PropTypes.func.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

CourseStep.defaultProps = {
  data: [],
  meta: {
    touched: false,
    error: '',
  },
};

export default withTranslation('common')(memo(CourseStep));
